var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.feedback)?_c('div',{staticClass:"feedback"},[_c('div',{staticClass:"feedback-title"},[_vm._v("\n        结果反馈 "),(_vm.feedbackAt)?_c('span',{staticClass:"feedback-time"},[_vm._v("反馈时间："+_vm._s(_vm.feedbackAt))]):_vm._e()]),_c('div',{staticClass:"feedback-content",domProps:{"innerHTML":_vm._s(_vm.feedback)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }